import React          from 'react';
import box_0          from '../images/box_0.png';
import DragableEgg    from './DragableEgg';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    root: {
        display:            'flex',
        alignItems:         'center',
        flexFlow:           'column',
    },
    img: {
        position:           'absolute',
        backgroundPosition: 'bottom',
        backgroundImage:    `url(${ box_0 })`,
        backgroundSize:     'contain',
        backgroundRepeat:   'no-repeat',
        transition:         'background 0.1s'
    },
    grid: {
        display:             'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
    },
    eggContainer: {
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
    },
    halfEggContainer: {
      position: 'absolute'
    },
    egg: {
       height:       '50%',
       width:        '50%',
       borderRadius: '50%',
       opacity:      0.5,
       transition:   'all 0.3s'
    },
    shake: {
        animation:               'shake 0.5s',
        animationIterationCount: '0.5s',
    },
      dont_shake: {
    }
}))

type EggBoxProps = {
    wideScreen:        boolean;
    disable:           boolean;
    drag:              boolean;
    putEggBackInBox:   boolean;
    showFinalValue:    boolean;
    draggedEgg:        number;
    value:             number;
    index:             number;
    disabledEggsArr:   number[];
    handleClick:       (ind: number, counter: number, val: number) => void
    handleRejection:   () => void;
    handleMouseDown:   (e: React.MouseEvent, ind: number) => void;
    handleTouchStart:  (e: React.TouchEvent, ind: number) => void;
}



const EggBox: React.FC<EggBoxProps> = ({ 
    wideScreen, 
    value, 
    disable, 
    drag, 
    index,
    putEggBackInBox,
    draggedEgg,
    showFinalValue,
    disabledEggsArr,
    handleClick, 
    handleRejection,
    handleMouseDown,
    handleTouchStart,
}) => {

  const classes = useStyles();

  const [selectedEggs, setSelectedEggs] = React.useState(new Array(10).fill(false))
  
  React.useEffect(() => {
    setSelectedEggs(new Array(10).fill(false))
  },[value, drag])

  React.useEffect(() => {
   if (showFinalValue) {
      setSelectedEggs(new Array(10).fill(false))
   }
 },[showFinalValue])


  const handleEggSelection = (val: number, ind: number) => {

        if (drag) {
            return
        }
      
        let arr = selectedEggs.slice();
   
        if (!arr[ind]) {
            if (!disable) {
               arr[ind] = true
            }
            else {
               handleRejection()
               handleClick(index, -1, val)
               return
            }
        }
        else {
           arr[ind] = false
           handleClick(index, -2, val)
        }
   
        let counter = 0;
        for(let i = 0; i < arr.length; i++) {
          if (arr[i]) {
             counter++
          }
        }
        setSelectedEggs(arr)
        handleClick(index, counter, val)
  }

  const [rootStyle, gridStyle] = React.useMemo(() => {
      return [
          {
             width:  wideScreen ? 250 : 150,
             height: wideScreen ? 90 : 40
          },
          {
            width:     wideScreen ? 225 : 104,
            height:    wideScreen ? 60 : 27,
            columnGap: wideScreen ? 10 : 2,
            zIndex:    drag ? 1 : 2
         },
      ]
  },[wideScreen, drag])

  return (
     <div 
        className = { classes.root }
        style     = { rootStyle }
     >
        <div
            className = { classes.img }
            style     = {{ 
               width:  wideScreen ? 250 : 150,
               height: wideScreen ? 90 : 40,
            }}
         />
         <div 
           className = { classes.halfEggContainer }
           style     = { rootStyle }
         >
         {
            new Array(value).fill(0).map((val, ind) => {

               const dontShow = disabledEggsArr.includes(ind + 1)

               return(
                  <DragableEgg
                      key                = { `DragableEgg%${ ind }` }
                      drag               = { drag }
                      wideScreen         = { wideScreen }
                      ind                = { ind }
                      index              = { index }
                      disable            = { disable }
                      dontShow           = { dontShow }
                      showFinalValue     = { showFinalValue }
                      putEggBackInBox    = { showFinalValue || (putEggBackInBox && draggedEgg === ind) }
                      handleMouseDown    = { handleMouseDown }
                      handleTouchStart   = { handleTouchStart }
                      handleRejection    = { handleRejection }
                  />
               )
            })
         }
         </div>
         <div 
            className = { classes.grid }
            style     = { gridStyle }
         >
             {
                  [2,4,6,8,10,1,3,5,7,9].map((val, ind) => {

                     const ignore = disabledEggsArr.includes(val)

                     return(
                         <div
                            key          = { `egg%%${ ind }` }
                            className    = { classes.eggContainer }
                            onClick      = { () => { 
                               //if (!selectedEggs[ind] && (!ignore && !disable && (val <= value))) { 
                               if (!ignore && (val <= value)) { 
                                    handleEggSelection(val, ind) 
                               }
                               else { handleRejection() }
                            }}
                         >
                            <div
                               className    = { classes.egg }
                               style        = {{
                                backgroundColor: !ignore && selectedEggs[ind] ? '#00F' : 'transparent',
                                boxShadow:       !ignore && selectedEggs[ind] ? `0px 0px 3px 3px #00F` : 'none',
                                cursor:          !ignore && !disable && val <= value ? 'pointer' : 'default',
                               }}
                            >
                               
                            </div>
                         </div>
                     )
                 })
             } 
         </div>
     </div>
  );
}



export default EggBox;








